import React from "react";
import PropTypes from "prop-types";

import useSheetStack from "../common/useSheetStack";
import SheetStack from "../common/SheetStack";
import { CC_V2_ADD, CC_V2_EDIT } from "./events";
import ComplaintForm from "./ComplaintForm";

/**
 * Chief complaint editor rail — a STACK of write sheets, newest on top.
 *
 * All of the stack behaviour (the blank-sheet guard, one-sheet-per-record,
 * serialised saves, the refusal pulse, the live region) lives in
 * ../common/useSheetStack + ../common/SheetStack, which every v3 rail shares.
 * This file is now only the section's wiring: which events open a sheet, how
 * to pull a complaint out of an edit payload, and what to call each sheet.
 */

const ADD = [CC_V2_ADD];
const EDIT = [CC_V2_EDIT];

const getRecord = (payload) => payload && payload.complaint;
const getRecordId = (c) => c && c.complaintId;
const dupMessage = (c) => `${c.complaint} is already open for update.`;

const ChiefComplaintEditor = ({ patient }) => {
  const patientId = patient && (patient.id || patient.patientID);

  const stack = useSheetStack({
    addEvents: ADD,
    editEvents: EDIT,
    getRecord,
    getRecordId,
    blankMessage: "A blank complaint form is already open.",
    dupMessage,
    enabled: !!patientId,
  });

  if (!patientId) {
    return <div className="ph-slot-empty is-editor"><p>Waiting for patient…</p></div>;
  }

  return (
    <SheetStack
      stack={stack}
      className="cc3-editor"
      describe={(s) => (s.editing ? `Update ${s.editing.complaint}` : "Add complaint")}
    >
      {(sheet, props) => <ComplaintForm patientId={patientId} {...props} />}
    </SheetStack>
  );
};

ChiefComplaintEditor.propTypes = {
  patient: PropTypes.object,
};

export default ChiefComplaintEditor;
